'use client'

import dynamic from 'next/dynamic'

export const UserAuthDialogClient = dynamic(
  () => import('components/user-auth-dialog').then(mod => mod.UserAuthDialog),
  {
    ssr: false,
  },
)
